// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { ApiHealthApiHealthGetData, ApiHealthApiHealthGetResponses, CancelInferenceJobApiV1InferenceJobsJobIdDeleteData, CancelInferenceJobApiV1InferenceJobsJobIdDeleteErrors, CancelInferenceJobApiV1InferenceJobsJobIdDeleteResponses, CancelTrainingJobApiV1TrainingJobsJobIdDeleteData, CancelTrainingJobApiV1TrainingJobsJobIdDeleteErrors, CancelTrainingJobApiV1TrainingJobsJobIdDeleteResponses, ConfirmFileUploadApiV1InferenceJobsJobIdFilesConfirmPostData, ConfirmFileUploadApiV1InferenceJobsJobIdFilesConfirmPostErrors, ConfirmFileUploadApiV1InferenceJobsJobIdFilesConfirmPostResponses, ConfirmUploadApiV1DatasetsDatasetIdAudioConfirmPostData, ConfirmUploadApiV1DatasetsDatasetIdAudioConfirmPostErrors, ConfirmUploadApiV1DatasetsDatasetIdAudioConfirmPostResponses, CreateAnnotationApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsPostData, CreateAnnotationApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsPostErrors, CreateAnnotationApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsPostResponses, CreateAnnotationsBulkApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsBulkPostData, CreateAnnotationsBulkApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsBulkPostErrors, CreateAnnotationsBulkApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsBulkPostResponses, CreateAnnotationSetApiV1DatasetsDatasetIdAnnotationSetsPostData, CreateAnnotationSetApiV1DatasetsDatasetIdAnnotationSetsPostErrors, CreateAnnotationSetApiV1DatasetsDatasetIdAnnotationSetsPostResponses, CreateApiKeyApiV1AuthApiKeysPostData, CreateApiKeyApiV1AuthApiKeysPostErrors, CreateApiKeyApiV1AuthApiKeysPostResponses, CreateCheckoutSessionApiV1BillingCheckoutPostData, CreateCheckoutSessionApiV1BillingCheckoutPostErrors, CreateCheckoutSessionApiV1BillingCheckoutPostResponses, CreateDatasetApiV1DatasetsPostData, CreateDatasetApiV1DatasetsPostErrors, CreateDatasetApiV1DatasetsPostResponses, CreateInferenceJobApiV1InferenceJobsPostData, CreateInferenceJobApiV1InferenceJobsPostErrors, CreateInferenceJobApiV1InferenceJobsPostResponses, CreateTrainingJobApiV1TrainingJobsPostData, CreateTrainingJobApiV1TrainingJobsPostErrors, CreateTrainingJobApiV1TrainingJobsPostResponses, DeleteAnnotationApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsAnnotationIdDeleteData, DeleteAnnotationApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsAnnotationIdDeleteErrors, DeleteAnnotationApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsAnnotationIdDeleteResponses, DeleteAnnotationSetApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdDeleteData, DeleteAnnotationSetApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdDeleteErrors, DeleteAnnotationSetApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdDeleteResponses, DeleteAudioFileApiV1DatasetsDatasetIdAudioAudioIdDeleteData, DeleteAudioFileApiV1DatasetsDatasetIdAudioAudioIdDeleteErrors, DeleteAudioFileApiV1DatasetsDatasetIdAudioAudioIdDeleteResponses, DeleteDatasetApiV1DatasetsDatasetIdDeleteData, DeleteDatasetApiV1DatasetsDatasetIdDeleteErrors, DeleteDatasetApiV1DatasetsDatasetIdDeleteResponses, DeleteModelApiV1ModelsModelIdDeleteData, DeleteModelApiV1ModelsModelIdDeleteErrors, DeleteModelApiV1ModelsModelIdDeleteResponses, ExportLabelStudioApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdExportLabelStudioGetData, ExportLabelStudioApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdExportLabelStudioGetErrors, ExportLabelStudioApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdExportLabelStudioGetResponses, GetAnnotationSetDetailApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdGetData, GetAnnotationSetDetailApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdGetErrors, GetAnnotationSetDetailApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdGetResponses, GetAudioFileApiV1DatasetsDatasetIdAudioAudioIdGetData, GetAudioFileApiV1DatasetsDatasetIdAudioAudioIdGetErrors, GetAudioFileApiV1DatasetsDatasetIdAudioAudioIdGetResponses, GetCurrentUserApiV1AuthMeGetData, GetCurrentUserApiV1AuthMeGetResponses, GetDatasetApiV1DatasetsDatasetIdGetData, GetDatasetApiV1DatasetsDatasetIdGetErrors, GetDatasetApiV1DatasetsDatasetIdGetResponses, GetDownloadUrlApiV1DatasetsDatasetIdAudioAudioIdDownloadUrlGetData, GetDownloadUrlApiV1DatasetsDatasetIdAudioAudioIdDownloadUrlGetErrors, GetDownloadUrlApiV1DatasetsDatasetIdAudioAudioIdDownloadUrlGetResponses, GetFileDownloadUrlApiV1InferenceJobsJobIdFilesFileIdDownloadUrlGetData, GetFileDownloadUrlApiV1InferenceJobsJobIdFilesFileIdDownloadUrlGetErrors, GetFileDownloadUrlApiV1InferenceJobsJobIdFilesFileIdDownloadUrlGetResponses, GetFileUploadUrlApiV1InferenceJobsJobIdFilesUploadUrlPostData, GetFileUploadUrlApiV1InferenceJobsJobIdFilesUploadUrlPostErrors, GetFileUploadUrlApiV1InferenceJobsJobIdFilesUploadUrlPostResponses, GetInferenceFileApiV1InferenceJobsJobIdFilesFileIdGetData, GetInferenceFileApiV1InferenceJobsJobIdFilesFileIdGetErrors, GetInferenceFileApiV1InferenceJobsJobIdFilesFileIdGetResponses, GetInferenceJobApiV1InferenceJobsJobIdGetData, GetInferenceJobApiV1InferenceJobsJobIdGetErrors, GetInferenceJobApiV1InferenceJobsJobIdGetResponses, GetModelApiV1ModelsModelIdGetData, GetModelApiV1ModelsModelIdGetErrors, GetModelApiV1ModelsModelIdGetResponses, GetSubscriptionApiV1BillingSubscriptionGetData, GetSubscriptionApiV1BillingSubscriptionGetResponses, GetTrainingJobApiV1TrainingJobsJobIdGetData, GetTrainingJobApiV1TrainingJobsJobIdGetErrors, GetTrainingJobApiV1TrainingJobsJobIdGetResponses, GetUploadUrlApiV1DatasetsDatasetIdAudioUploadUrlPostData, GetUploadUrlApiV1DatasetsDatasetIdAudioUploadUrlPostErrors, GetUploadUrlApiV1DatasetsDatasetIdAudioUploadUrlPostResponses, GetUsageApiV1BillingUsageGetData, GetUsageApiV1BillingUsageGetResponses, GetUsageHistoryApiV1BillingUsageHistoryGetData, GetUsageHistoryApiV1BillingUsageHistoryGetErrors, GetUsageHistoryApiV1BillingUsageHistoryGetResponses, HealthCheckHealthGetData, HealthCheckHealthGetResponses, ListAnnotationsApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsGetData, ListAnnotationsApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsGetErrors, ListAnnotationsApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsGetResponses, ListAnnotationSetsApiV1DatasetsDatasetIdAnnotationSetsGetData, ListAnnotationSetsApiV1DatasetsDatasetIdAnnotationSetsGetErrors, ListAnnotationSetsApiV1DatasetsDatasetIdAnnotationSetsGetResponses, ListApiKeysApiV1AuthApiKeysGetData, ListApiKeysApiV1AuthApiKeysGetResponses, ListAudioFilesApiV1DatasetsDatasetIdAudioGetData, ListAudioFilesApiV1DatasetsDatasetIdAudioGetErrors, ListAudioFilesApiV1DatasetsDatasetIdAudioGetResponses, ListDatasetsApiV1DatasetsGetData, ListDatasetsApiV1DatasetsGetResponses, ListInferenceFilesApiV1InferenceJobsJobIdFilesGetData, ListInferenceFilesApiV1InferenceJobsJobIdFilesGetErrors, ListInferenceFilesApiV1InferenceJobsJobIdFilesGetResponses, ListInferenceJobsApiV1InferenceJobsGetData, ListInferenceJobsApiV1InferenceJobsGetErrors, ListInferenceJobsApiV1InferenceJobsGetResponses, ListModelsApiV1ModelsGetData, ListModelsApiV1ModelsGetErrors, ListModelsApiV1ModelsGetResponses, ListTrainingJobsApiV1TrainingJobsGetData, ListTrainingJobsApiV1TrainingJobsGetErrors, ListTrainingJobsApiV1TrainingJobsGetResponses, LoginApiV1AuthLoginPostData, LoginApiV1AuthLoginPostErrors, LoginApiV1AuthLoginPostResponses, PublishAnnotationSetApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdPublishPostData, PublishAnnotationSetApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdPublishPostErrors, PublishAnnotationSetApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdPublishPostResponses, RevokeApiKeyApiV1AuthApiKeysKeyIdDeleteData, RevokeApiKeyApiV1AuthApiKeysKeyIdDeleteErrors, RevokeApiKeyApiV1AuthApiKeysKeyIdDeleteResponses, SignupApiV1AuthSignupPostData, SignupApiV1AuthSignupPostErrors, SignupApiV1AuthSignupPostResponses, StripeWebhookApiV1WebhooksStripePostData, StripeWebhookApiV1WebhooksStripePostResponses, SyncUsageToStripeApiV1BillingSyncUsagePostData, SyncUsageToStripeApiV1BillingSyncUsagePostResponses, UpdateAnnotationApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsAnnotationIdPatchData, UpdateAnnotationApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsAnnotationIdPatchErrors, UpdateAnnotationApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsAnnotationIdPatchResponses, UpdateDatasetApiV1DatasetsDatasetIdPatchData, UpdateDatasetApiV1DatasetsDatasetIdPatchErrors, UpdateDatasetApiV1DatasetsDatasetIdPatchResponses, UpdateModelApiV1ModelsModelIdPatchData, UpdateModelApiV1ModelsModelIdPatchErrors, UpdateModelApiV1ModelsModelIdPatchResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Api Health
 *
 * API health check.
 */
export const apiHealthApiHealthGet = <ThrowOnError extends boolean = false>(options?: Options<ApiHealthApiHealthGetData, ThrowOnError>) => (options?.client ?? client).get<ApiHealthApiHealthGetResponses, unknown, ThrowOnError>({ url: '/api/health', ...options });

/**
 * Signup
 *
 * Create a new tenant account.
 */
export const signupApiV1AuthSignupPost = <ThrowOnError extends boolean = false>(options: Options<SignupApiV1AuthSignupPostData, ThrowOnError>) => (options.client ?? client).post<SignupApiV1AuthSignupPostResponses, SignupApiV1AuthSignupPostErrors, ThrowOnError>({
    url: '/api/v1/auth/signup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Login
 *
 * Authenticate and get access token.
 */
export const loginApiV1AuthLoginPost = <ThrowOnError extends boolean = false>(options: Options<LoginApiV1AuthLoginPostData, ThrowOnError>) => (options.client ?? client).post<LoginApiV1AuthLoginPostResponses, LoginApiV1AuthLoginPostErrors, ThrowOnError>({
    url: '/api/v1/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Current User
 *
 * Get current authenticated tenant.
 */
export const getCurrentUserApiV1AuthMeGet = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentUserApiV1AuthMeGetData, ThrowOnError>) => (options?.client ?? client).get<GetCurrentUserApiV1AuthMeGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/auth/me',
    ...options
});

/**
 * List Api Keys
 *
 * List all API keys for the tenant.
 */
export const listApiKeysApiV1AuthApiKeysGet = <ThrowOnError extends boolean = false>(options?: Options<ListApiKeysApiV1AuthApiKeysGetData, ThrowOnError>) => (options?.client ?? client).get<ListApiKeysApiV1AuthApiKeysGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/auth/api-keys',
    ...options
});

/**
 * Create Api Key
 *
 * Create a new API key for the tenant.
 */
export const createApiKeyApiV1AuthApiKeysPost = <ThrowOnError extends boolean = false>(options: Options<CreateApiKeyApiV1AuthApiKeysPostData, ThrowOnError>) => (options.client ?? client).post<CreateApiKeyApiV1AuthApiKeysPostResponses, CreateApiKeyApiV1AuthApiKeysPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/auth/api-keys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Api Key
 *
 * Revoke an API key.
 */
export const revokeApiKeyApiV1AuthApiKeysKeyIdDelete = <ThrowOnError extends boolean = false>(options: Options<RevokeApiKeyApiV1AuthApiKeysKeyIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<RevokeApiKeyApiV1AuthApiKeysKeyIdDeleteResponses, RevokeApiKeyApiV1AuthApiKeysKeyIdDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/auth/api-keys/{key_id}',
    ...options
});

/**
 * List Datasets
 *
 * List all datasets for the current tenant.
 */
export const listDatasetsApiV1DatasetsGet = <ThrowOnError extends boolean = false>(options?: Options<ListDatasetsApiV1DatasetsGetData, ThrowOnError>) => (options?.client ?? client).get<ListDatasetsApiV1DatasetsGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets',
    ...options
});

/**
 * Create Dataset
 *
 * Create a new dataset.
 */
export const createDatasetApiV1DatasetsPost = <ThrowOnError extends boolean = false>(options: Options<CreateDatasetApiV1DatasetsPostData, ThrowOnError>) => (options.client ?? client).post<CreateDatasetApiV1DatasetsPostResponses, CreateDatasetApiV1DatasetsPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Dataset
 *
 * Delete a dataset and all associated data.
 */
export const deleteDatasetApiV1DatasetsDatasetIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteDatasetApiV1DatasetsDatasetIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteDatasetApiV1DatasetsDatasetIdDeleteResponses, DeleteDatasetApiV1DatasetsDatasetIdDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets/{dataset_id}',
    ...options
});

/**
 * Get Dataset
 *
 * Get a specific dataset by ID.
 */
export const getDatasetApiV1DatasetsDatasetIdGet = <ThrowOnError extends boolean = false>(options: Options<GetDatasetApiV1DatasetsDatasetIdGetData, ThrowOnError>) => (options.client ?? client).get<GetDatasetApiV1DatasetsDatasetIdGetResponses, GetDatasetApiV1DatasetsDatasetIdGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets/{dataset_id}',
    ...options
});

/**
 * Update Dataset
 *
 * Update a dataset.
 */
export const updateDatasetApiV1DatasetsDatasetIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateDatasetApiV1DatasetsDatasetIdPatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateDatasetApiV1DatasetsDatasetIdPatchResponses, UpdateDatasetApiV1DatasetsDatasetIdPatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets/{dataset_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Upload Url
 *
 * Generate a presigned URL for direct S3 upload.
 *
 * This endpoint:
 * 1. Validates the dataset exists and belongs to the tenant
 * 2. Creates a pending AudioFile record in the database
 * 3. Generates a presigned POST URL for direct browser upload to S3
 *
 * The client should:
 * 1. Use the returned URL and fields to construct a multipart/form-data POST
 * 2. Upload the file directly to S3
 * 3. Call the confirm endpoint to mark the upload as complete
 */
export const getUploadUrlApiV1DatasetsDatasetIdAudioUploadUrlPost = <ThrowOnError extends boolean = false>(options: Options<GetUploadUrlApiV1DatasetsDatasetIdAudioUploadUrlPostData, ThrowOnError>) => (options.client ?? client).post<GetUploadUrlApiV1DatasetsDatasetIdAudioUploadUrlPostResponses, GetUploadUrlApiV1DatasetsDatasetIdAudioUploadUrlPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets/{dataset_id}/audio/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Upload
 *
 * Confirm that an audio file upload has completed.
 *
 * This endpoint:
 * 1. Verifies the file exists in S3
 * 2. Updates the audio file status
 * 3. Queues the file for processing (normalization + embedding)
 *
 * The client should call this after successfully uploading to S3.
 */
export const confirmUploadApiV1DatasetsDatasetIdAudioConfirmPost = <ThrowOnError extends boolean = false>(options: Options<ConfirmUploadApiV1DatasetsDatasetIdAudioConfirmPostData, ThrowOnError>) => (options.client ?? client).post<ConfirmUploadApiV1DatasetsDatasetIdAudioConfirmPostResponses, ConfirmUploadApiV1DatasetsDatasetIdAudioConfirmPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets/{dataset_id}/audio/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Audio Files
 *
 * List all audio files in a dataset with pagination.
 *
 * Supports filtering by processing status:
 * - pending: Awaiting upload confirmation
 * - normalizing: Being processed (normalized audio)
 * - embedding: Generating embeddings
 * - ready: Fully processed and ready for use
 * - failed: Processing failed
 */
export const listAudioFilesApiV1DatasetsDatasetIdAudioGet = <ThrowOnError extends boolean = false>(options: Options<ListAudioFilesApiV1DatasetsDatasetIdAudioGetData, ThrowOnError>) => (options.client ?? client).get<ListAudioFilesApiV1DatasetsDatasetIdAudioGetResponses, ListAudioFilesApiV1DatasetsDatasetIdAudioGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets/{dataset_id}/audio',
    ...options
});

/**
 * Delete Audio File
 *
 * Delete an audio file and its associated data.
 *
 * This will:
 * 1. Delete the audio file record from the database
 * 2. Delete the original file from S3
 * 3. Delete any normalized/embedding files from S3
 */
export const deleteAudioFileApiV1DatasetsDatasetIdAudioAudioIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteAudioFileApiV1DatasetsDatasetIdAudioAudioIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteAudioFileApiV1DatasetsDatasetIdAudioAudioIdDeleteResponses, DeleteAudioFileApiV1DatasetsDatasetIdAudioAudioIdDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets/{dataset_id}/audio/{audio_id}',
    ...options
});

/**
 * Get Audio File
 *
 * Get details of a specific audio file.
 */
export const getAudioFileApiV1DatasetsDatasetIdAudioAudioIdGet = <ThrowOnError extends boolean = false>(options: Options<GetAudioFileApiV1DatasetsDatasetIdAudioAudioIdGetData, ThrowOnError>) => (options.client ?? client).get<GetAudioFileApiV1DatasetsDatasetIdAudioAudioIdGetResponses, GetAudioFileApiV1DatasetsDatasetIdAudioAudioIdGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets/{dataset_id}/audio/{audio_id}',
    ...options
});

/**
 * Get Download Url
 *
 * Generate a presigned download URL for an audio file.
 *
 * By default returns a URL for the original uploaded file.
 * Set normalized=true to get the normalized version (if processing is complete).
 */
export const getDownloadUrlApiV1DatasetsDatasetIdAudioAudioIdDownloadUrlGet = <ThrowOnError extends boolean = false>(options: Options<GetDownloadUrlApiV1DatasetsDatasetIdAudioAudioIdDownloadUrlGetData, ThrowOnError>) => (options.client ?? client).get<GetDownloadUrlApiV1DatasetsDatasetIdAudioAudioIdDownloadUrlGetResponses, GetDownloadUrlApiV1DatasetsDatasetIdAudioAudioIdDownloadUrlGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets/{dataset_id}/audio/{audio_id}/download-url',
    ...options
});

/**
 * List Annotation Sets
 *
 * List all annotation sets for a dataset.
 */
export const listAnnotationSetsApiV1DatasetsDatasetIdAnnotationSetsGet = <ThrowOnError extends boolean = false>(options: Options<ListAnnotationSetsApiV1DatasetsDatasetIdAnnotationSetsGetData, ThrowOnError>) => (options.client ?? client).get<ListAnnotationSetsApiV1DatasetsDatasetIdAnnotationSetsGetResponses, ListAnnotationSetsApiV1DatasetsDatasetIdAnnotationSetsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets/{dataset_id}/annotation-sets',
    ...options
});

/**
 * Create Annotation Set
 *
 * Create a new annotation set (draft).
 *
 * Each annotation set has an auto-incremented version number.
 * New sets start as drafts and must be published before training.
 */
export const createAnnotationSetApiV1DatasetsDatasetIdAnnotationSetsPost = <ThrowOnError extends boolean = false>(options: Options<CreateAnnotationSetApiV1DatasetsDatasetIdAnnotationSetsPostData, ThrowOnError>) => (options.client ?? client).post<CreateAnnotationSetApiV1DatasetsDatasetIdAnnotationSetsPostResponses, CreateAnnotationSetApiV1DatasetsDatasetIdAnnotationSetsPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets/{dataset_id}/annotation-sets',
    ...options
});

/**
 * Delete Annotation Set
 *
 * Delete an annotation set.
 *
 * Only draft annotation sets can be deleted.
 */
export const deleteAnnotationSetApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteAnnotationSetApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteAnnotationSetApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdDeleteResponses, DeleteAnnotationSetApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets/{dataset_id}/annotation-sets/{annotation_set_id}',
    ...options
});

/**
 * Get Annotation Set Detail
 *
 * Get annotation set with all annotations.
 */
export const getAnnotationSetDetailApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdGet = <ThrowOnError extends boolean = false>(options: Options<GetAnnotationSetDetailApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdGetData, ThrowOnError>) => (options.client ?? client).get<GetAnnotationSetDetailApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdGetResponses, GetAnnotationSetDetailApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets/{dataset_id}/annotation-sets/{annotation_set_id}',
    ...options
});

/**
 * Publish Annotation Set
 *
 * Publish an annotation set.
 *
 * Once published, the annotation set becomes immutable.
 * Stats are computed and stored for quick access.
 */
export const publishAnnotationSetApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdPublishPost = <ThrowOnError extends boolean = false>(options: Options<PublishAnnotationSetApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdPublishPostData, ThrowOnError>) => (options.client ?? client).post<PublishAnnotationSetApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdPublishPostResponses, PublishAnnotationSetApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdPublishPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets/{dataset_id}/annotation-sets/{annotation_set_id}/publish',
    ...options
});

/**
 * List Annotations
 *
 * List annotations with optional filters.
 */
export const listAnnotationsApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsGet = <ThrowOnError extends boolean = false>(options: Options<ListAnnotationsApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsGetData, ThrowOnError>) => (options.client ?? client).get<ListAnnotationsApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsGetResponses, ListAnnotationsApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets/{dataset_id}/annotation-sets/{annotation_set_id}/annotations',
    ...options
});

/**
 * Create Annotation
 *
 * Create a single annotation.
 */
export const createAnnotationApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsPost = <ThrowOnError extends boolean = false>(options: Options<CreateAnnotationApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsPostData, ThrowOnError>) => (options.client ?? client).post<CreateAnnotationApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsPostResponses, CreateAnnotationApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets/{dataset_id}/annotation-sets/{annotation_set_id}/annotations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Annotations Bulk
 *
 * Create multiple annotations at once.
 */
export const createAnnotationsBulkApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsBulkPost = <ThrowOnError extends boolean = false>(options: Options<CreateAnnotationsBulkApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsBulkPostData, ThrowOnError>) => (options.client ?? client).post<CreateAnnotationsBulkApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsBulkPostResponses, CreateAnnotationsBulkApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsBulkPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets/{dataset_id}/annotation-sets/{annotation_set_id}/annotations/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Annotation
 *
 * Delete an annotation.
 */
export const deleteAnnotationApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsAnnotationIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteAnnotationApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsAnnotationIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteAnnotationApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsAnnotationIdDeleteResponses, DeleteAnnotationApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsAnnotationIdDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets/{dataset_id}/annotation-sets/{annotation_set_id}/annotations/{annotation_id}',
    ...options
});

/**
 * Update Annotation
 *
 * Update an annotation.
 */
export const updateAnnotationApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsAnnotationIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateAnnotationApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsAnnotationIdPatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateAnnotationApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsAnnotationIdPatchResponses, UpdateAnnotationApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdAnnotationsAnnotationIdPatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets/{dataset_id}/annotation-sets/{annotation_set_id}/annotations/{annotation_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export Label Studio
 *
 * Export annotations in Label Studio format.
 *
 * This format can be imported into Label Studio for editing
 * or used with Label Studio ML backend.
 */
export const exportLabelStudioApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdExportLabelStudioGet = <ThrowOnError extends boolean = false>(options: Options<ExportLabelStudioApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdExportLabelStudioGetData, ThrowOnError>) => (options.client ?? client).get<ExportLabelStudioApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdExportLabelStudioGetResponses, ExportLabelStudioApiV1DatasetsDatasetIdAnnotationSetsAnnotationSetIdExportLabelStudioGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/datasets/{dataset_id}/annotation-sets/{annotation_set_id}/export/label-studio',
    ...options
});

/**
 * List Training Jobs
 *
 * List training jobs for the tenant.
 */
export const listTrainingJobsApiV1TrainingJobsGet = <ThrowOnError extends boolean = false>(options?: Options<ListTrainingJobsApiV1TrainingJobsGetData, ThrowOnError>) => (options?.client ?? client).get<ListTrainingJobsApiV1TrainingJobsGetResponses, ListTrainingJobsApiV1TrainingJobsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/training-jobs',
    ...options
});

/**
 * Create Training Job
 *
 * Create a new training job.
 *
 * Requirements:
 * - Dataset must belong to tenant
 * - Annotation set must be published
 * - All audio files must have embeddings computed
 * - At least 5 minutes of total audio
 */
export const createTrainingJobApiV1TrainingJobsPost = <ThrowOnError extends boolean = false>(options: Options<CreateTrainingJobApiV1TrainingJobsPostData, ThrowOnError>) => (options.client ?? client).post<CreateTrainingJobApiV1TrainingJobsPostResponses, CreateTrainingJobApiV1TrainingJobsPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/training-jobs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel Training Job
 *
 * Cancel a pending or running training job.
 */
export const cancelTrainingJobApiV1TrainingJobsJobIdDelete = <ThrowOnError extends boolean = false>(options: Options<CancelTrainingJobApiV1TrainingJobsJobIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<CancelTrainingJobApiV1TrainingJobsJobIdDeleteResponses, CancelTrainingJobApiV1TrainingJobsJobIdDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/training-jobs/{job_id}',
    ...options
});

/**
 * Get Training Job
 *
 * Get training job details with progress and metrics.
 */
export const getTrainingJobApiV1TrainingJobsJobIdGet = <ThrowOnError extends boolean = false>(options: Options<GetTrainingJobApiV1TrainingJobsJobIdGetData, ThrowOnError>) => (options.client ?? client).get<GetTrainingJobApiV1TrainingJobsJobIdGetResponses, GetTrainingJobApiV1TrainingJobsJobIdGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/training-jobs/{job_id}',
    ...options
});

/**
 * List Models
 *
 * List trained models for the tenant.
 */
export const listModelsApiV1ModelsGet = <ThrowOnError extends boolean = false>(options?: Options<ListModelsApiV1ModelsGetData, ThrowOnError>) => (options?.client ?? client).get<ListModelsApiV1ModelsGetResponses, ListModelsApiV1ModelsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/models',
    ...options
});

/**
 * Delete Model
 *
 * Delete a model.
 *
 * This archives the model rather than hard deleting.
 */
export const deleteModelApiV1ModelsModelIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteModelApiV1ModelsModelIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteModelApiV1ModelsModelIdDeleteResponses, DeleteModelApiV1ModelsModelIdDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/models/{model_id}',
    ...options
});

/**
 * Get Model
 *
 * Get model details with metrics.
 */
export const getModelApiV1ModelsModelIdGet = <ThrowOnError extends boolean = false>(options: Options<GetModelApiV1ModelsModelIdGetData, ThrowOnError>) => (options.client ?? client).get<GetModelApiV1ModelsModelIdGetResponses, GetModelApiV1ModelsModelIdGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/models/{model_id}',
    ...options
});

/**
 * Update Model
 *
 * Update model name, description, or active status.
 */
export const updateModelApiV1ModelsModelIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateModelApiV1ModelsModelIdPatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateModelApiV1ModelsModelIdPatchResponses, UpdateModelApiV1ModelsModelIdPatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/models/{model_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Inference Jobs
 *
 * List inference jobs for the tenant.
 */
export const listInferenceJobsApiV1InferenceJobsGet = <ThrowOnError extends boolean = false>(options?: Options<ListInferenceJobsApiV1InferenceJobsGetData, ThrowOnError>) => (options?.client ?? client).get<ListInferenceJobsApiV1InferenceJobsGetResponses, ListInferenceJobsApiV1InferenceJobsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/inference-jobs',
    ...options
});

/**
 * Create Inference Job
 *
 * Create a new inference job.
 *
 * The job is created in 'pending' status. Add files using the upload endpoints,
 * then files will be queued for processing automatically.
 */
export const createInferenceJobApiV1InferenceJobsPost = <ThrowOnError extends boolean = false>(options: Options<CreateInferenceJobApiV1InferenceJobsPostData, ThrowOnError>) => (options.client ?? client).post<CreateInferenceJobApiV1InferenceJobsPostResponses, CreateInferenceJobApiV1InferenceJobsPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/inference-jobs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel Inference Job
 *
 * Cancel a pending or processing inference job.
 */
export const cancelInferenceJobApiV1InferenceJobsJobIdDelete = <ThrowOnError extends boolean = false>(options: Options<CancelInferenceJobApiV1InferenceJobsJobIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<CancelInferenceJobApiV1InferenceJobsJobIdDeleteResponses, CancelInferenceJobApiV1InferenceJobsJobIdDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/inference-jobs/{job_id}',
    ...options
});

/**
 * Get Inference Job
 *
 * Get inference job details with files and detections.
 */
export const getInferenceJobApiV1InferenceJobsJobIdGet = <ThrowOnError extends boolean = false>(options: Options<GetInferenceJobApiV1InferenceJobsJobIdGetData, ThrowOnError>) => (options.client ?? client).get<GetInferenceJobApiV1InferenceJobsJobIdGetResponses, GetInferenceJobApiV1InferenceJobsJobIdGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/inference-jobs/{job_id}',
    ...options
});

/**
 * List Inference Files
 *
 * List files in an inference job.
 */
export const listInferenceFilesApiV1InferenceJobsJobIdFilesGet = <ThrowOnError extends boolean = false>(options: Options<ListInferenceFilesApiV1InferenceJobsJobIdFilesGetData, ThrowOnError>) => (options.client ?? client).get<ListInferenceFilesApiV1InferenceJobsJobIdFilesGetResponses, ListInferenceFilesApiV1InferenceJobsJobIdFilesGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/inference-jobs/{job_id}/files',
    ...options
});

/**
 * Get Inference File
 *
 * Get inference file with detections.
 */
export const getInferenceFileApiV1InferenceJobsJobIdFilesFileIdGet = <ThrowOnError extends boolean = false>(options: Options<GetInferenceFileApiV1InferenceJobsJobIdFilesFileIdGetData, ThrowOnError>) => (options.client ?? client).get<GetInferenceFileApiV1InferenceJobsJobIdFilesFileIdGetResponses, GetInferenceFileApiV1InferenceJobsJobIdFilesFileIdGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/inference-jobs/{job_id}/files/{file_id}',
    ...options
});

/**
 * Get File Upload Url
 *
 * Get a presigned URL to upload a file for inference.
 *
 * Returns a presigned URL that can be used to upload the file directly to S3.
 * After upload, call confirm endpoint to start processing.
 */
export const getFileUploadUrlApiV1InferenceJobsJobIdFilesUploadUrlPost = <ThrowOnError extends boolean = false>(options: Options<GetFileUploadUrlApiV1InferenceJobsJobIdFilesUploadUrlPostData, ThrowOnError>) => (options.client ?? client).post<GetFileUploadUrlApiV1InferenceJobsJobIdFilesUploadUrlPostResponses, GetFileUploadUrlApiV1InferenceJobsJobIdFilesUploadUrlPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/inference-jobs/{job_id}/files/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm File Upload
 *
 * Confirm file upload and queue for processing.
 *
 * Call this after uploading the file to S3 using the presigned URL.
 * This will queue the file for inference processing.
 */
export const confirmFileUploadApiV1InferenceJobsJobIdFilesConfirmPost = <ThrowOnError extends boolean = false>(options: Options<ConfirmFileUploadApiV1InferenceJobsJobIdFilesConfirmPostData, ThrowOnError>) => (options.client ?? client).post<ConfirmFileUploadApiV1InferenceJobsJobIdFilesConfirmPostResponses, ConfirmFileUploadApiV1InferenceJobsJobIdFilesConfirmPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/inference-jobs/{job_id}/files/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get File Download Url
 *
 * Get a presigned URL to download the original audio file.
 */
export const getFileDownloadUrlApiV1InferenceJobsJobIdFilesFileIdDownloadUrlGet = <ThrowOnError extends boolean = false>(options: Options<GetFileDownloadUrlApiV1InferenceJobsJobIdFilesFileIdDownloadUrlGetData, ThrowOnError>) => (options.client ?? client).get<GetFileDownloadUrlApiV1InferenceJobsJobIdFilesFileIdDownloadUrlGetResponses, GetFileDownloadUrlApiV1InferenceJobsJobIdFilesFileIdDownloadUrlGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/inference-jobs/{job_id}/files/{file_id}/download-url',
    ...options
});

/**
 * Create Checkout Session
 *
 * Create a Stripe checkout session for subscription.
 *
 * This redirects the user to Stripe's hosted checkout page.
 * After successful payment, Stripe sends a webhook to confirm.
 */
export const createCheckoutSessionApiV1BillingCheckoutPost = <ThrowOnError extends boolean = false>(options: Options<CreateCheckoutSessionApiV1BillingCheckoutPostData, ThrowOnError>) => (options.client ?? client).post<CreateCheckoutSessionApiV1BillingCheckoutPostResponses, CreateCheckoutSessionApiV1BillingCheckoutPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/billing/checkout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Subscription
 *
 * Get current subscription status and details.
 */
export const getSubscriptionApiV1BillingSubscriptionGet = <ThrowOnError extends boolean = false>(options?: Options<GetSubscriptionApiV1BillingSubscriptionGetData, ThrowOnError>) => (options?.client ?? client).get<GetSubscriptionApiV1BillingSubscriptionGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/billing/subscription',
    ...options
});

/**
 * Get Usage
 *
 * Get current billing period usage.
 */
export const getUsageApiV1BillingUsageGet = <ThrowOnError extends boolean = false>(options?: Options<GetUsageApiV1BillingUsageGetData, ThrowOnError>) => (options?.client ?? client).get<GetUsageApiV1BillingUsageGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/billing/usage',
    ...options
});

/**
 * Get Usage History
 *
 * Get monthly usage history.
 */
export const getUsageHistoryApiV1BillingUsageHistoryGet = <ThrowOnError extends boolean = false>(options?: Options<GetUsageHistoryApiV1BillingUsageHistoryGetData, ThrowOnError>) => (options?.client ?? client).get<GetUsageHistoryApiV1BillingUsageHistoryGetResponses, GetUsageHistoryApiV1BillingUsageHistoryGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/billing/usage/history',
    ...options
});

/**
 * Sync Usage To Stripe
 *
 * Manually sync usage to Stripe (for testing).
 *
 * In production, this runs as a scheduled job.
 */
export const syncUsageToStripeApiV1BillingSyncUsagePost = <ThrowOnError extends boolean = false>(options?: Options<SyncUsageToStripeApiV1BillingSyncUsagePostData, ThrowOnError>) => (options?.client ?? client).post<SyncUsageToStripeApiV1BillingSyncUsagePostResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/v1/billing/sync-usage',
    ...options
});

/**
 * Stripe Webhook
 *
 * Handle Stripe webhook events.
 *
 * Events handled:
 * - checkout.session.completed: Subscription created
 * - customer.subscription.updated: Subscription changed
 * - customer.subscription.deleted: Subscription canceled
 * - invoice.payment_failed: Payment failed
 */
export const stripeWebhookApiV1WebhooksStripePost = <ThrowOnError extends boolean = false>(options?: Options<StripeWebhookApiV1WebhooksStripePostData, ThrowOnError>) => (options?.client ?? client).post<StripeWebhookApiV1WebhooksStripePostResponses, unknown, ThrowOnError>({ url: '/api/v1/webhooks/stripe', ...options });

/**
 * Health Check
 *
 * Health check endpoint.
 */
export const healthCheckHealthGet = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckHealthGetData, ThrowOnError>) => (options?.client ?? client).get<HealthCheckHealthGetResponses, unknown, ThrowOnError>({ url: '/health', ...options });
